import React, { useEffect, useRef } from 'react';
import { v4 as uuidv4 } from 'uuid';

import { SwiperSlide, Swiper } from 'swiper/react';
import SwiperCore, {Navigation} from 'swiper';

import 'swiper/css';
import 'swiper/css/navigation';

import Image from '../imageComponent';
import { arrLeft, arrRight } from '../../svgs';
import { PictureSliderWrapper, PictureSlide } from './styled';

SwiperCore.use([Navigation]);

const CenterSlider: React.FC<{ slides: any }> = ({ slides }) => {  
  // swiper 
  const prevRef = useRef<HTMLDivElement>(null);
  const nextRef = useRef<HTMLDivElement>(null);

  return (
    <PictureSliderWrapper>
      <Swiper
        className="blog-gallery"
        centeredSlides
        loop
        speed={250}
        navigation={{
          prevEl: prevRef.current,
          nextEl: nextRef.current,
        }}
        onSwiper={(swiper) => {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          // eslint-disable-next-line no-param-reassign
          swiper.params.navigation.prevEl = prevRef.current;
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          // eslint-disable-next-line no-param-reassign
          swiper.params.navigation.nextEl = nextRef.current;
          swiper.navigation.init();
          swiper.navigation.update();
        }}
        breakpoints={{
          300: {
            slidesPerView: 1.2,
            spaceBetween: 12,
          },  
          741: {
            slidesPerView: 1.35,
            spaceBetween: 12,
          },
        }}
      >
        {/* custom btns */}
        <div className="btn" ref={prevRef}>
          {arrLeft()}
        </div>

        <div className="btn" ref={nextRef}>
          {arrRight()}
        </div>

        {slides.map((el, i) => {
          return (
            <SwiperSlide key={uuidv4()}>
              <PictureSlide>
                <Image src={el.src} alt={el.alt} />
              </PictureSlide>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </PictureSliderWrapper>
  );
};

export default CenterSlider;
